import { PaxCostBand, SlidingScalePricingItem } from '~/types/tours/costPrice';

/**
 * One sliding scale row: a single season of a single package option, which is
 * both the grain of the supplier's CSV and of svc-tour's upload payload.
 */
export interface SlidingScaleRow {
  key: string;
  season: string;
  /** Package and option as one label, e.g. "Base-Regular". */
  configurationLabel: string;
  currency: string;
  singleSupplement: number;
  bands: Array<PaxCostBand>;
}

/** svc-tour stores the scale positionally: index 0 is the rate for 1 pax. */
export function scaleToBands(scale: Array<number>): Array<PaxCostBand> {
  return scale.map((unitPrice, index) => ({ pax: index + 1, unitPrice }));
}

export function buildSlidingScaleRows(items: Array<SlidingScalePricingItem>): Array<SlidingScaleRow> {
  return items.map((item, index) => ({
    key: `${item.tourConfiguration}-${item.packageConfiguration}-${item.season}-${item.currency}-${index}`,
    season: item.season,
    configurationLabel: `${item.tourConfiguration}-${item.packageConfiguration}`,
    currency: item.currency,
    singleSupplement: item.singleSupplement,
    bands: scaleToBands(item.scale),
  }));
}

/** Every pax point across all rows, ascending, for building table columns. */
export function getPaxPoints(rows: Array<SlidingScaleRow>): Array<number> {
  const points = new Set<number>();
  rows.forEach((row) => row.bands.forEach((band) => points.add(band.pax)));
  return Array.from(points).sort((a, b) => a - b);
}
